import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
    plugins: [createPersistedState()],
    state: {
        backend: process.env.VUE_APP_BACKEND_URL,
        //backend: 'https://api.swiset.com/api',
        analyticsUrl: 'https://us-central1-swiset-admin.cloudfunctions.net/app',
        token: '',
        desktop: false,
        currentUser: {
            id: 0,
            firstName: '',
            lastName: '',
            email: '',
            imageUrl: 'https://swiset.com/wp-content/uploads/2019/12/Responsive.jpg',
        },
        users: [],
        userPagination: {
            totalPages: 0,
            currentPage: 1,
            size: 10
        },
        lastUpdate: null,
    },
    actions: {

    },
    mutations: {
        setToken(state, token) {
            state.token = token;
        },
        setDesktop(state, desktop) {
            state.desktop = desktop;
        },
        setCurrentUser(state, user) {
            state.currentUser.id = user.id;
            state.currentUser.firstName = user.firstName;
            state.currentUser.lastName = user.lastName;
            state.currentUser.email = user.email;
            state.currentUser.imageUrl = user.imageUrl;
        },
        setUsers(state, users) {
            state.users = users;
        },
        setUserPagination(state, { totalPages, currentPage }) {
            state.userPagination.totalPages = totalPages;
            state.userPagination.currentPage = currentPage;
        },
        setLastUpdate(state, lastUpdate) {
            state.lastUpdate = lastUpdate;
        },
        logout(state) {
            state.token = '';
            state.currentUser = {
                id: 0,
                firstName: '',
                lastName: '',
                email: '',
                imageUrl: 'https://swiset.com/wp-content/uploads/2019/12/Responsive.jpg',
            };
        }
    }
});
